/* CartesianGrid.tsx generated by @compiled/babel-plugin v0.28.8 */
import "./CartesianGrid.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function CartesianGrid(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: ax(["_1e0c1txw _kqswh2mm _16jlkb7n _1tkeidpf _1ul9idpf"]),
    children: /*#__PURE__*/_jsx("div", {
      className: ax(["_1e0c11p5 _yv0ey09t _2z051qft _zulp1nty _1lmcpu6d _1ul9idpf _1tkeidpf _1bsb1osq _4t3i1osq"]),
      children: children
    })
  });
}